(() => {
  const qa = (root, selector) => [...root.querySelectorAll(selector)];
  const desktopQuery = window.matchMedia('(min-width: 901px)');
  const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const swapImage = (image, src, alt = '', delay = 180) => {
    if (!image || !src || image.getAttribute('src') === src) return;
    window.clearTimeout(image._k2cSwapTimer);
    image.style.opacity = '0';
    image.style.transform = 'translateY(8px) scale(.995)';
    image._k2cSwapTimer = window.setTimeout(() => {
      image.src = src;
      image.alt = alt;
      requestAnimationFrame(() => {
        image.style.opacity = '1';
        image.style.transform = 'none';
      });
    }, reduceMotionQuery.matches ? 0 : delay);
  };

  const initOptions = (root) => {
    if (!root || root.dataset.k2cOptionsReady === 'true') return;
    root.dataset.k2cOptionsReady = 'true';

    const productForm = document.querySelector('.k2-product-form');
    const mount = productForm && productForm.querySelector('.k2-buy-row');
    const standard = root.querySelector('[data-k2c-standard]');
    if (productForm && mount && standard) mount.before(standard);

    const tabs = qa(root, '[data-k2c-tab]');
    const panels = qa(root, '[data-k2c-panel]');
    const typeInput = root.querySelector('[data-k2c-type]');
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const key = tab.dataset.k2cTab;
      tabs.forEach((item) => item.classList.toggle('is-active', item === tab));
      panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.k2cPanel === key));
      if (typeInput) typeInput.value = key === 'text' ? 'Text' : key === 'image' ? 'Image' : 'Image + Text';
    }));

    const trigger = standard && standard.querySelector('[data-k2c-request-trigger]');
    const modal = root.querySelector('[data-k2c-request-modal]');
    if (trigger && modal) trigger.addEventListener('click', () => {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    });
    qa(root, '[data-k2c-request-close]').forEach((close) => close.addEventListener('click', () => {
      modal.hidden = true;
      document.body.style.overflow = '';
    }));
  };

  const initProcess = (root) => {
    if (!root || root.dataset.k2cProcessReady === 'true') return;
    root.dataset.k2cProcessReady = 'true';

    const steps = qa(root, '[data-k2c-step]');
    const desktopImage = root.querySelector('[data-k2c-process-image]');
    let activeIndex = Math.max(0, steps.findIndex((step) => step.classList.contains('is-active')));
    let demoTimer;
    let demoStarted = false;
    let userControlled = false;

    const activate = (index, fromUser = false) => {
      if (!steps.length) return;
      activeIndex = (index + steps.length) % steps.length;
      if (fromUser) {
        userControlled = true;
        window.clearTimeout(demoTimer);
      }

      steps.forEach((step, stepIndex) => {
        const active = stepIndex === activeIndex;
        step.classList.toggle('is-active', active);
        step.setAttribute('aria-expanded', active ? 'true' : 'false');
      });

      const active = steps[activeIndex];
      root.classList.toggle('is-engraving', active.dataset.k2cStep === '3');
      if (desktopQuery.matches) swapImage(desktopImage, active.dataset.image, active.dataset.alt || '', 220);
    };

    const startDesktopDemo = () => {
      if (!desktopQuery.matches || reduceMotionQuery.matches || demoStarted || userControlled || steps.length < 2) return;
      demoStarted = true;
      let nextIndex = activeIndex;
      let remaining = steps.length - 1;
      const next = () => {
        if (userControlled || remaining <= 0 || !desktopQuery.matches) return;
        nextIndex = (nextIndex + 1) % steps.length;
        activate(nextIndex);
        remaining -= 1;
        if (remaining > 0) demoTimer = window.setTimeout(next, 2000);
      };
      demoTimer = window.setTimeout(next, 1600);
    };

    steps.forEach((step, index) => {
      const trigger = step.querySelector('[data-k2c-step-trigger]') || step;
      trigger.addEventListener('click', () => activate(index, true));
      step.addEventListener('mouseenter', () => {
        if (desktopQuery.matches) activate(index, true);
      });
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        activate(index, true);
      });
    });

    activate(activeIndex);
    if ('IntersectionObserver' in window) {
      const entranceObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        startDesktopDemo();
        entranceObserver.disconnect();
      }, { threshold: .3 });
      entranceObserver.observe(root);
      root._k2cProcessObserver = entranceObserver;
    } else {
      startDesktopDemo();
    }

    const handleViewportChange = () => {
      window.clearTimeout(demoTimer);
      activate(activeIndex);
      if (desktopQuery.matches) startDesktopDemo();
    };
    desktopQuery.addEventListener('change', handleViewportChange);
    root._k2cViewportHandler = handleViewportChange;
  };

  const initStories = (root) => {
    if (!root || root.dataset.k2cReady === 'true') return;
    root.dataset.k2cReady = 'true';

    const buttons = qa(root, '[data-k2c-story]');
    const image = root.querySelector('[data-k2c-story-image]');
    const mobileSource = root.querySelector('[data-k2c-story-source]');
    const heading = root.querySelector('[data-k2c-story-heading]');
    const copy = root.querySelector('[data-k2c-story-copy]');
    const selectors = root.querySelector('[data-k2c-story-selectors]');
    const swipe = root.querySelector('[data-k2c-story-swipe]');
    const progress = root.querySelector('[data-k2c-story-progress]');
    let activeButton = buttons.find((button) => button.classList.contains('is-active')) || buttons[0];

    const syncStoryImage = (button, animate = true) => {
      if (!button || !image) return;
      const desktopSrc = button.dataset.imageDesktop || button.dataset.imageMobile || '';
      const mobileSrc = button.dataset.imageMobile || desktopSrc;
      if (mobileSource && mobileSrc) mobileSource.srcset = mobileSrc;
      const visibleSrc = desktopQuery.matches ? desktopSrc : mobileSrc;
      swapImage(image, visibleSrc, button.dataset.alt || '', animate ? 180 : 0);
    };

    const updateScrollProgress = () => {
      if (!selectors || !swipe || !progress) return;
      const scrollable = selectors.scrollWidth > selectors.clientWidth + 2;
      swipe.classList.toggle('is-hidden', !scrollable);
      const maxScroll = Math.max(1, selectors.scrollWidth - selectors.clientWidth);
      const ratio = Math.min(1, Math.max(0, selectors.scrollLeft / maxScroll));
      progress.style.transform = `translateX(${ratio * 300}%)`;
    };

    const activate = (button, options = {}) => {
      if (!button) return;
      activeButton = button;
      buttons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      syncStoryImage(button, options.animate !== false);
      if (heading) heading.textContent = button.dataset.title || '';
      if (copy) copy.textContent = button.dataset.copy || '';
      if (options.reveal && !desktopQuery.matches) {
        button.scrollIntoView({ behavior: reduceMotionQuery.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button, { reveal: true }));
      button.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          const next = buttons[(index + 1) % buttons.length];
          next.focus();
          activate(next, { reveal: true });
          return;
        }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          const previous = buttons[(index - 1 + buttons.length) % buttons.length];
          previous.focus();
          activate(previous, { reveal: true });
          return;
        }
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        activate(button, { reveal: true });
      });
    });

    if (selectors) selectors.addEventListener('scroll', updateScrollProgress, { passive: true });
    const handleStoryViewportChange = () => {
      syncStoryImage(activeButton, false);
      requestAnimationFrame(updateScrollProgress);
    };
    desktopQuery.addEventListener('change', handleStoryViewportChange);
    window.addEventListener('resize', updateScrollProgress, { passive: true });
    root._k2cStoryViewportHandler = handleStoryViewportChange;
    root._k2cStoryResizeHandler = updateScrollProgress;

    if (activeButton) activate(activeButton, { animate: false });
    requestAnimationFrame(updateScrollProgress);
  };

  const initWithin = (scope = document) => {
    const includeSelf = (selector) => scope.matches && scope.matches(selector) ? [scope] : [];
    [...includeSelf('[data-k2c-options]'), ...qa(scope, '[data-k2c-options]')].forEach(initOptions);
    [...includeSelf('[data-k2c-process]'), ...qa(scope, '[data-k2c-process]')].forEach(initProcess);
    [...includeSelf('[data-k2c-stories]'), ...qa(scope, '[data-k2c-stories]')].forEach(initStories);
  };

  initWithin(document);
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector && event.target.querySelector('[data-k2c-stories]');
    if (!root) return;
    if (root._k2cStoryViewportHandler) desktopQuery.removeEventListener('change', root._k2cStoryViewportHandler);
    if (root._k2cStoryResizeHandler) window.removeEventListener('resize', root._k2cStoryResizeHandler);
  });
  document.addEventListener('shopify:block:select', (event) => {
    let selectable = event.target.closest && event.target.closest('[data-k2c-story], [data-k2c-step]');
    if (!selectable && event.detail && event.detail.blockId) {
      selectable = qa(document, '[data-k2c-story], [data-k2c-step]').find((item) =>
        (item.getAttribute('data-shopify-editor-block') || '').includes(`"id":"${event.detail.blockId}"`)
      );
    }
    if (selectable) {
      const trigger = selectable.matches('[data-k2c-step]') ? selectable.querySelector('[data-k2c-step-trigger]') : selectable;
      if (trigger) trigger.click();
    }
  });

  if (!window.K2CInquiryModalBound) {
    window.K2CInquiryModalBound = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-k2c-inquiry-trigger]');
      const close = event.target.closest('[data-k2c-inquiry-close]');
      if (trigger) {
        const root = trigger.closest('[data-k2c-inquiry]');
        const modal = root && root.querySelector('[data-k2c-inquiry-modal]');
        if (modal) {
          modal.hidden = false;
          document.body.style.overflow = 'hidden';
          const email = modal.querySelector('input[type="email"]');
          if (email) window.setTimeout(() => email.focus(), 50);
        }
      }
      if (close) {
        const modal = close.closest('[data-k2c-inquiry-modal]');
        if (modal) {
          modal.hidden = true;
          document.body.style.overflow = '';
        }
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const modal = document.querySelector('[data-k2c-inquiry-modal]:not([hidden])');
      if (modal) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    });
  }
})();
